<div class="staff-template">
  @if (loading) {
    <div class="text-center" style="width: 100%; position: absolute; height: 50vh; top: 45%">
      <mat-spinner style="display: inline-block" diameter="24"></mat-spinner>
    </div>
  }

  <div class="staff-info ag-pa-md">
    <!-- modify request -->
    @if (staff.type === 'modifyRequest') {
      <div #modifyRequest>
        <h4>Modify Existing Request</h4>
        <div class="form-group">
          <label for="modifyEditRequest">Enter Request ID for the request you want to Modify</label>
          <input
            #modifyEditRequest
            type="text"
            [(ngModel)]="modifyReqId"
            class="form-control"
            id="modifyEditRequest"
          />
        </div>
        <div class="form-check">
          <input
            #newLenderList
            type="checkbox"
            class="form-check-input"
            id="newLenderList"
            [(ngModel)]="generateNewLenderList"
          />
          <label class="form-check-label" for="newLenderList">Generate new Lender List</label>
        </div>
        <br />
        <button
          role="button"
          aria-label="Submit"
          type="submit"
          class="btn btn-primary float-end"
          (click)="submitModifyRequest()"
        >
          Submit
        </button>
      </div>
    }

    <!-- add location -->
    @if (staff.type === 'addLocation' && bibInfo) {
      <div>
        <form #form="ngForm">
          <h4>Add Locations</h4>
          <div fxLayout="column" fxLayoutGap="10px">
            <ng-container
              *ngTemplateOutlet="bibData; context: { $implicit: bibInfo }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="selectLibrary; context: { $implicit: allLibraries }"
            ></ng-container>
            @if (selectedLibrary) {
              <ng-container
                *ngTemplateOutlet="holdingForm; context: { $implicit: newHolding }"
              ></ng-container>
            }
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
              <div>
                @if (selectedLibrary) {
                  <button
                    role="button"
                    type="button"
                    aria-label="Add"
                    class="btn btn-primary"
                    (click)="addLocation()"
                  >
                    Add Location
                  </button>
                }
              </div>
              <div>
                <button
                  role="button"
                  aria-label="Cancel"
                  type="button"
                  class="btn btn-secondary"
                  (click)="closeNav()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }

    <!-- copy catalog-->
    @if (staff.type === 'copyCatalog' && bibInfo) {
      <div>
        <form #form="ngForm">
          <h4>Copy Locations</h4>
          <div fxLayout="column" fxLayoutGap="10px">
            <ng-container
              *ngTemplateOutlet="bibData; context: { $implicit: bibInfo }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="selectLibrary; context: { $implicit: allLibraries }"
            ></ng-container>
            @if (selectedLibrary) {
              <ng-container
                *ngTemplateOutlet="holdingForm; context: { $implicit: newHolding }"
              ></ng-container>
            }
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
              <div>
                <button
                  role="button"
                  type="button"
                  aria-label="Copy Catalog"
                  class="btn btn-primary"
                  (click)="copyCatalog()"
                >
                  Add
                </button>
              </div>
              <div>
                <button
                  role="button"
                  aria-label="Cancel"
                  type="button"
                  class="btn btn-secondary"
                  (click)="closeNav()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }

    <!-- edit location -->
    @if (staff.type === 'editLocation' && bibInfo) {
      <div>
        <form>
          <h4>Edit Locations</h4>
          <div fxLayout="column" fxLayoutGap="10px">
            <ng-container
              *ngTemplateOutlet="bibData; context: { $implicit: bibInfo }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="selectLibrary; context: { $implicit: libraries }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="selectHolding; context: { $implicit: selectLibraryHoldings }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="holdingForm; context: { $implicit: selectedHolding }"
            ></ng-container>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
              <div>
                @if (selectedHolding) {
                  <button
                    role="button"
                    type="button"
                    aria-label="Update"
                    class="btn btn-primary"
                    (click)="updateLocation()"
                  >
                    Update Location
                  </button>
                }
              </div>
              <div>
                <button
                  role="button"
                  aria-label="Cancel"
                  type="button"
                  class="btn btn-secondary"
                  (click)="closeNav()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }

    <!-- delete location -->
    @if (staff.type === 'deleteLocation' && bibInfo) {
      <div>
        <h4>Delete Locations</h4>
        <div fxLayout="column" fxLayoutGap="10px">
          <ng-container *ngTemplateOutlet="bibData; context: { $implicit: bibInfo }"></ng-container>
          <ng-container
            *ngTemplateOutlet="selectLibrary; context: { $implicit: libraries }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="selectHolding; context: { $implicit: selectLibraryHoldings }"
          ></ng-container>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
            <div>
              @if (selectedHolding) {
                <button
                  role="button"
                  type="button"
                  aria-label="Delete"
                  class="btn btn-primary"
                  (click)="deleteLocation()"
                >
                  Delete Location
                </button>
              }
            </div>
            <div>
              <button
                role="button"
                aria-label="Cancel"
                type="button"
                class="btn btn-secondary"
                (click)="closeNav()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #bibData let-data>
  <div fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="80px" fxLayout="column">Title:</div>
      <div fxLayout="column">{{ data.title }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="80px" fxLayout="column">Author:</div>
      <div fxLayout="column">{{ data.author }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="80px" fxLayout="column">Publisher:</div>
      <div fxLayout="column">{{ data.publisher }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="80px" fxLayout="column">Date:</div>
      <div fxLayout="column">{{ data.date }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="80px" fxLayout="column">Format:</div>
      <div fxLayout="column">{{ data.format }}</div>
    </div>
  </div>
</ng-template>

<ng-template #selectLibrary let-libraries>
  <!-- If there are mulitple library, user must first select libraries to add location to-->
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Library</mat-label>
      <mat-select
        title="Select Library"
        class="header-color"
        [(ngModel)]="selectedLibrary"
        (selectionChange)="onLibrarySelection()"
      >
        @for (lib of libraries; track lib) {
          <mat-option [value]="lib"> {{ lib.name }} ({{ lib.libCode }}) </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #selectHolding let-holdings>
  @if (holdings) {
    <mat-radio-group fxLayout="column" name="holdings" [(ngModel)]="selectedHolding">
      @for (item of holdings; track item) {
        <mat-radio-button [value]="item">{{ item.hldContent }} </mat-radio-button>
      }
    </mat-radio-group>
  }
</ng-template>

<ng-template #holdingForm let-holding>
  @if (holding) {
    @for (item of holding.hldDetails; track item) {
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        @if (!item.isLibraryField) {
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{ item.description }}</mat-label>
            <input
              id="{{ 'subfield_' + item.subfieldTag }}"
              matInput
              type="text"
              [(ngModel)]="item.value"
              [readonly]="!item.editable"
            />
          </mat-form-field>
        }
      </div>
    }
  }
</ng-template>
